<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <article>
        <h2>통합검색 서비스</h2>
        <ul class="breadCrumb">
          <li class="home"></li>
          <li>
            <p class="pageTxt">통합검색 서비스</p>
          </li>
        </ul>
      </article>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="container">
      <div class="inner w1080">
        <!-- 본문 영역 -->
        <section id="content">
          <article class="srhTabArea">
            <p class="pageTitle">
              검색어<em> “정기권” </em>에 대한 전체 <em class="colorType purple"> “14” </em>개의 결과를 찾았습니다.
            </p>
            <div class="srhTabBox">
              <dl role="radiogroup">
                <dt>정렬</dt>
                <dd><input type="radio" id="" name="sort" value="정확도" checked /><label for="">정확도</label></dd>
                <dd><input type="radio" id="" name="sort" value="최신순" /><label for="">최신순</label></dd>
              </dl>
              <dl role="radiogroup">
                <dt>기간</dt>
                <dd><input type="radio" id="" name="date" value="전체" checked /><label for="">전체</label></dd>
                <dd><input type="radio" id="" name="date" value="1주일" /><label for="">1주일</label></dd>
                <dd><input type="radio" id="" name="date" value="1개월" /><label for="">1개월</label></dd>
              </dl>
            </div>
          </article>
          <article class="srhResult">
            <article>
              <h2>
                메뉴검색 <em>(총<span class="colorType purple"> 3</span>건)</em>
              </h2>
              <ul class="path dotType">
                <li>주차서비스</li>
                <li><span>정기권</span> 안내</li>
              </ul>
              <ul class="path dotType">
                <li>주차서비스</li>
                <li><span>정기권</span> 안내</li>
              </ul>
              <ul class="path dotType">
                <li>주차서비스</li>
                <li><span>정기권</span> 안내</li>
              </ul>
            </article>
            <article>
              <h2>
                공지사항 <em>(총<span class="colorType purple"> 3</span>건)</em>
              </h2>
              <ul class="list">
                <li>
                  <a href="/">
                    <div class="boardTitle">
                      <p class="tit">2023 주차 정기권 신청 안내 공고</p>
                      <div class="date">
                        <span>관리자</span>
                        <span>2022-08-30</span>
                      </div>
                    </div>
                    <div class="boardText">
                      모든 국민은 근로의 권리를 가진다. 국가는 사회적·경제적 방법으로 근로자의 고용의 증진과 적정임금의
                      보장에 노력하여야 하며, 법률이 정하는 바에 의하여 최저임금제를 시행하여야 한다. 모든 국민은
                      거주·이전의 자유를 가진다. 모든 국민은 능력에 따라 균등하게 교육을 받을 권리를 가진다. 연소자의
                      근로는 특별한 보호를 받는다. 국가는 농수산물의 수급균형과 유통구조의 개선에 노력하여 가격안정을
                      도모함으로써 농·어민의 이익을 보호한다. 국무회의는 정부의 권한에 속하는 중요한 정책을 심의한다.
                      환경권의 내용과 행사에 관하여는 법률로 정한다. 대통령의 임기연장 또는 중임변경을 위한 헌법개정은
                      그 헌법개정 제안 당…
                    </div>
                    <ul class="path">
                      <li>정보마당</li>
                      <li>공지사항</li>
                    </ul>
                  </a>
                </li>
                <li>
                  <a href="/">
                    <div class="boardTitle">
                      <p class="tit">2023 주차 정기권 신청 안내 공고</p>
                      <div class="date">
                        <span>관리자</span>
                        <span>2022-08-30</span>
                      </div>
                    </div>
                    <div class="boardText">
                      모든 국민은 근로의 권리를 가진다. 국가는 사회적·경제적 방법으로 근로자의 고용의 증진과 적정임금의
                      보장에 노력하여야 하며, 법률이 정하는 바에 의하여 최저임금제를 시행하여야 한다. 모든 국민은
                      거주·이전의 자유를 가진다. 모든 국민은 능력에 따라 균등하게 교육을 받을 권리를 가진다. 연소자의
                      근로는 특별한 보호를 받는다. 국가는 농수산물의 수급균형과 유통구조의 개선에 노력하여 가격안정을
                      도모함으로써 농·어민의 이익을 보호한다. 국무회의는 정부의 권한에 속하는 중요한 정책을 심의한다.
                      환경권의 내용과 행사에 관하여는 법률로 정한다. 대통령의 임기연장 또는 중임변경을 위한 헌법개정은
                      그 헌법개정 제안 당…
                    </div>
                    <ul class="path">
                      <li>정보마당</li>
                      <li>공지사항</li>
                    </ul>
                  </a>
                </li>
                <li>
                  <a href="/">
                    <div class="boardTitle">
                      <p class="tit">2023 주차 정기권 신청 안내 공고</p>
                      <div class="date">
                        <span>관리자</span>
                        <span>2022-08-30</span>
                      </div>
                    </div>
                    <div class="boardText">
                      모든 국민은 근로의 권리를 가진다. 국가는 사회적·경제적 방법으로 근로자의 고용의 증진과 적정임금의
                      보장에 노력하여야 하며, 법률이 정하는 바에 의하여 최저임금제를 시행하여야 한다. 모든 국민은
                      거주·이전의 자유를 가진다. 모든 국민은 능력에 따라 균등하게 교육을 받을 권리를 가진다. 연소자의
                      근로는 특별한 보호를 받는다. 국가는 농수산물의 수급균형과 유통구조의 개선에 노력하여 가격안정을
                      도모함으로써 농·어민의 이익을 보호한다. 국무회의는 정부의 권한에 속하는 중요한 정책을 심의한다.
                      환경권의 내용과 행사에 관하여는 법률로 정한다. 대통령의 임기연장 또는 중임변경을 위한 헌법개정은
                      그 헌법개정 제안 당…
                    </div>
                    <ul class="path">
                      <li>정보마당</li>
                      <li>공지사항</li>
                    </ul>
                  </a>
                </li>
              </ul>
            </article>
            <article>
              <h2>
                자주묻는질문 <em>(총<span class="colorType purple"> 3</span>건)</em>
              </h2>
              <ul class="list">
                <li>
                  <a href="/">
                    <div class="boardTitle">
                      <p class="tit">2023 주차 정기권 신청 안내 공고</p>
                    </div>
                    <div class="boardText">
                      모든 국민은 근로의 권리를 가진다. 국가는 사회적·경제적 방법으로 근로자의 고용의 증진과 적정임금의
                      보장에 노력하여야 하며, 법률이 정하는 바에 의하여 최저임금제를 시행하여야 한다. 모든 국민은
                      거주·이전의 자유를 가진다. 모든 국민은 능력에 따라 균등하게 교육을 받을 권리를 가진다. 연소자의
                      근로는 특별한 보호를 받는다. 국가는 농수산물의 수급균형과 유통구조의 개선에 노력하여 가격안정을
                      도모함으로써 농·어민의 이익을 보호한다. 국무회의는 정부의 권한에 속하는 중요한 정책을 심의한다.
                      환경권의 내용과 행사에 관하여는 법률로 정한다. 대통령의 임기연장 또는 중임변경을 위한 헌법개정은
                      그 헌법개정 제안 당…
                    </div>
                    <ul class="path">
                      <li>정보마당</li>
                      <li>자주묻는질문</li>
                    </ul>
                  </a>
                </li>
                <li>
                  <a href="/">
                    <div class="boardTitle">
                      <p class="tit">2023 주차 정기권 신청 안내 공고</p>
                    </div>
                    <div class="boardText">
                      모든 국민은 근로의 권리를 가진다. 국가는 사회적·경제적 방법으로 근로자의 고용의 증진과 적정임금의
                      보장에 노력하여야 하며, 법률이 정하는 바에 의하여 최저임금제를 시행하여야 한다. 모든 국민은
                      거주·이전의 자유를 가진다. 모든 국민은 능력에 따라 균등하게 교육을 받을 권리를 가진다. 연소자의
                      근로는 특별한 보호를 받는다. 국가는 농수산물의 수급균형과 유통구조의 개선에 노력하여 가격안정을
                      도모함으로써 농·어민의 이익을 보호한다. 국무회의는 정부의 권한에 속하는 중요한 정책을 심의한다.
                      환경권의 내용과 행사에 관하여는 법률로 정한다. 대통령의 임기연장 또는 중임변경을 위한 헌법개정은
                      그 헌법개정 제안 당…
                    </div>
                    <ul class="path">
                      <li>정보마당</li>
                      <li>자주묻는질문</li>
                    </ul>
                  </a>
                </li>
              </ul>
            </article>
          </article>
        </section>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  data() {
    return {};
  },

  components: {},

  mounted() {
    let category = this.$route.meta.category;
    EventBus.$emit('emitCategory', category);
  },

  methods: {},
};
</script>
